import React from 'react'
import cx from 'classnames'
import { number, oneOfType, string } from 'prop-types'

import styles from './radio-button.module.css'

const propTypes = {
    id: oneOfType([string, number])
}

/**
 * Label for radio buttons
 *
 * @property {string|number} [props.id] - The input id attribute
 * @returns {ReactElement} The rendered component
 */
export function RadioButtonLabel({ children, className, id, ...props }) {
    return (
        <label
            data-testid="radio-button-label"
            htmlFor={id}
            className={cx(styles['radio-button-label'], className)}
            {...props}
        >
            {children}
        </label>
    )
}

RadioButtonLabel.propTypes = propTypes
